import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';
import Pagination from '../../components/Pagination/Pagination';
import SearchSymbol from '../../components/SearchSymbol/SearchSymbol';
import Toast from '../../components/Toast/Toast';
import { getProdutos } from '../../services/ProdutosService';
// import ProdutosRow from './ProdutosRow';
import NewProdutoButton from './NewProdutoButton';
// import ProdutoModal from './ProdutoModal/ProdutoModal';

// 4.372,18

function LojaList() {

    const API_URL = process.env.REACT_APP_IMG_URL;
    const imagemUrl = `${API_URL}/api/images/`;

    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [search, setSearch] = useState(params.nome || '');
    const [editProduto, setEditProduto] = useState({});
    const [Produtos, setProdutos] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(parseInt(new URLSearchParams(location.search).get('page') || '1'));
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [carrinho, setCarrinho] = useState([]); // Estado do carrinho
    const [quantidades, setQuantidades] = useState({}); // Estado para armazenar quantidades por produto

    const [debouncedSearch] = useDebounce(search, 500);
    // const carrinho = 6;


    // Later in the useEffect hook
    useEffect(() => {
        const token = localStorage.getItem('token');
        getProdutos(debouncedSearch, page, token).then(result => {
            setProdutos(result.rows);
            setCount(result.count);
        }).catch(err => {
            console.error(err.response ? err.response.data : err.message);
            setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
        });
    }, [debouncedSearch, page]);


    useEffect(() => {
        function handleLocationChange(location) {
            const newPage = parseInt(new URLSearchParams(location.search).get('page') || '1');
            setPage(newPage);
        }

        handleLocationChange(location); // Initialize with current location

        // Potencialmente, adicionar um listener aqui se necessário para mudanças de localização
        // return () => { removeListener(); };
    }, [location]);

    useEffect(() => {
        const carrinhoSalvo = localStorage.getItem("carrinho");
        if (carrinhoSalvo) {
            setCarrinho(JSON.parse(carrinhoSalvo));
        }
    }, []);

    const onSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const onNewProdutoClick = () => {
        setEditProduto({ nome: '', isActive: true });
    };

    const onEditClick = (event) => {
        const id = parseInt(event.target.id.replace('edit', ''));
        setEditProduto(Produtos.find(u => u.id === id));
    };

    const onModalSubmit = () => {
        navigate(0);
    };


    // Atualiza a quantidade de um produto
    const atualizarQuantidade = (produtoId, novaQuantidade) => {
        setQuantidades((prev) => ({
            ...prev,
            [produtoId]: novaQuantidade >= 1 ? novaQuantidade : 1, // Garante que a quantidade mínima seja 1
        }));
    };


    // Função para adicionar ao carrinho
    // Adiciona um produto ao carrinho com a quantidade selecionada
    // const adicionarAoCarrinho = (produto) => {
    //     const quantidade = quantidades[produto.id] || 1; // Usa a quantidade definida ou 1 como padrão

    //     // Adiciona ao carrinho com a quantidade selecionada
    //     setCarrinho((prev) => [...prev, { ...produto, quantidade }]);
    //     alert(`${quantidade}x ${produto.nome} foi adicionado ao carrinho!`);
    // };
    const adicionarAoCarrinho = (produto) => {
        const quantidade = quantidades[produto.id] || 1;
        const novoCarrinho = [...carrinho, { ...produto, quantidade }];
        setCarrinho(novoCarrinho);
        localStorage.setItem("carrinho", JSON.stringify(novoCarrinho));
        alert(`${quantidade}x ${produto.nome} foi adicionado ao carrinho!`);
    };

    return (
        <React.Fragment>
            <Menu />
            <main className="content">
                {/* Cabeçalho da página */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        {/* <h1 className="h4">Produtos...</h1> */}
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent mb-0">
                                <li className="breadcrumb-item">
                                    <a href="#">
                                        <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                                    </a>
                                </li>
                                {/* <li className="breadcrumb-item"><a href="#">Category</a></li> */}
                                <li className="breadcrumb-item active" aria-current="page">Produto</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="btn-toolbar mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            {/* Exibe a quantidade de itens no carrinho */}
                            <div className="row">
                                <div className="col-12">
                                    {/* <button className="btn btn-success"> 🛒  ({carrinho.length} itens) </button>  &nbsp; */}
                                    <div className="text-end mb-3">
                                        <a href="/carrinho" className="btn btn-warning">
                                            🛒 Carrinho ({carrinho.reduce((total, item) => total + item.quantidade, 0)} itens)
                                        </a>
                                    </div>

                                    {/* </div>
                                <div className="col-8"> */}
                                    {/* <NewProdutoButton onClick={onNewProdutoClick} /> */}
                                </div>
                            </div>
                        </div>
                        <div className="ms-2 ms-lg-3">
                            {/* Campo para consulta */}

                            <SearchSymbol placeholder="Produto" onChange={onSearchChange} />
                        </div>
                    </div>
                </div>

                {/* <h1 className="h4">3 - Pontos - Montar tela..</h1> */}

                <div className="row">
                    <div className="col-12">
                        {/* Corpo da pagina */}
                        {/* INICIO DA TABELA */}
                        <div className="card card-body border-0 shadow table-wrapper table-responsive">

                            <div className="row">
                                {Produtos.map((produto) => (
                                    <div key={produto.id} className="col-md-3 mb-3">
                                        <div className="card shadow-sm h-100">
                                            <img
                                                src={imagemUrl + produto.imagen}
                                                className="card-img-top"
                                                alt={produto.nome}
                                                style={{
                                                    width: "100%",
                                                    height: "150px",
                                                    objectFit: "contain",
                                                    display: "block",
                                                    margin: "auto",
                                                }}
                                            />
                                            <div className="card-body d-flex flex-column">
                                                <h5 className="card-title">{produto.nome}</h5>
                                                <p className="card-text text-muted flex-grow-1">{produto.descricao}</p>
                                                <h4 className="text-primary fw-bold">R$ {produto.preco.toFixed(2)}</h4>
                                                {/* Campo de quantidade */}
                                                <div className="d-flex align-items-center mt-2">
                                                    <label className="me-2">Quantidade:</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={quantidades[produto.id] || 1}
                                                        onChange={(e) => atualizarQuantidade(produto.id, parseInt(e.target.value))}
                                                        style={{ width: "80px" }}
                                                        min="1"
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-success mt-2"
                                                    onClick={() => adicionarAoCarrinho(produto)}
                                                >
                                                    ➕ Adicionar ao Carrinho
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>




                            <Pagination count={count} />
                        </div>
                        {/* FINAL DA TABELA */}


                    </div>
                </div>
                {/* Rodape da página */}
                <Footer />
            </main>
            {/* <ProdutoModal data={editProduto} onSubmit={onModalSubmit} /> */}
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default LojaList;